import { FC } from "react";
import { useParams } from "react-router-dom";

import { CrudEditContextWrapper } from "@ryde/controls";
import { useCrudNavigate } from "@ryde/redux";
import { DrawerType, EditFormMode } from "@ryde/shared";

import { SystemParamsDrawerEditFormInner } from ".";
import { DrawerFormProviderWrapper } from "../../drawers/components/edit-form/drawer-form-provider-wrapper";

interface ISystemParamsEdit {
  isAddRoute?: boolean;
}

export const SystemParamsEdit: FC<ISystemParamsEdit> = ({ isAddRoute }) => {
  const { id } = useParams<{ id: string }>();
  const { navigateToList } = useCrudNavigate("systemParam");

  const idOpen = Number(id) && !isAddRoute ? Number(id) : undefined;
  const idCopyFrom = Number(id) && isAddRoute ? Number(id) : undefined;

  return (
    <CrudEditContextWrapper
      entity="systemParam"
      id={idOpen}
      idCopyFrom={idCopyFrom}
      mode={EditFormMode.CrudRoute}
    >
      <DrawerFormProviderWrapper>
        <SystemParamsDrawerEditFormInner
          type={DrawerType.EditForm}
          entity="systemParam"
          mode={EditFormMode.CrudRoute}
          onCloseDrawer={navigateToList}
        />
      </DrawerFormProviderWrapper>
    </CrudEditContextWrapper>
  );
};
